exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accordion{padding:0;margin-bottom:calc(var(--body-baseline) * 2)}.accordion div:not(:last-child){border-bottom:1px solid hsla(0,0%,4%,.1)}.accordion div:last-child .accordion-item-details{border-radius:5px}.accordion dd{margin-left:0;margin-left:var(--gutter)}", ""]);

// exports
